@if (!utskriftFormGroup.disabled) {
<div [formGroup]="utskriftFormGroup" class="d-flex col-12">
    @if (!isKontrakt()) {
    <div class="col-1">
        <rask-checkbox
            formControlName="selected">
        </rask-checkbox>
    </div>
    }
    <div class="filename-column col-11">
        <div>
            <a
                [title]="utskrift.dokumentNamn"
                href="javascript:void(0)"
                (click)="openKontrakt(utskrift.id)"
                class="fw-bold filename">{{utskrift.dokumentNamn}}</a>
            <a href="javascript:void(0)" (click)="downloadDokument(utskrift)"
                class="btn btn-lg btn-icon" title="Ladda ner dokumentet">
                <span class="fas fa-download fa-xs"></span>
            </a>
        </div>
        <div>
            <span class="text-muted">Version {{ utskrift.version }}, {{
                utskrift.skapadTid |
                date
                }}</span>
        </div>
        <ng-template #openFileDisabled>
            <div class="filename file-locked">{{utskrift.dokumentNamn}}</div>
        </ng-template>
    </div>
</div>
}